<template>
   <div>
      <div v-show="!showInfoCertificado" class="divRenovarCertificadoImg">
         <img src="../../../assets/images/renovar-certificado.png" alt="Imagem para descrever a renovação do certificado digital.">
         <button @click="handleShowRenovarCertificado()" style="padding: 0 21px!important" class="btnRenovarCertificadoImg">Renovar</button>
      </div>
      <div 
         v-show="showInfoCertificado"
         id="h4-Cert-DigitalElement" 
         cert-token="T-5a6f64" 
         cert-company="C-8a0193" 
         accountant="A-626df1" 
         f="F-2" 
         p="P-14" 
      />
   </div>
</template>

<script>
export default {
   data: () => ({
      showInfoCertificado: false,
   }),
   props: ["dialog"],
   beforeMount () {
      this.$root.$el.parentNode.appendChild(this.$root.$el);
   },
   watch: {
      dialog: function(newV, oldV) {
         if(newV) {
            this.$mount();
         }else {
            setTimeout(() => {
               this.showInfoCertificado = false;
               this.$store.commit('addDialogWidthRC', 1000);
            }, 400);
         }
      },
   },
   methods: {
      handleShowRenovarCertificado: function() {
         this.$store.commit('addDialogWidthRC', 935);
         this.showInfoCertificado = true;
      }
   }
}
</script>

<style>
   #h4-Cert-DigitalElement .h4_cert_modal {
      max-width: 800px!important;
   }

   #h4-Cert-DigitalElement {
      width: 800px;
   }

   .divRenovarCertificadoImg {
      position: relative;
   }

   .divRenovarCertificadoImg img {
      width: 100%;
   }

   .btnRenovarCertificadoImg {
      position: absolute;
      bottom: 62px;
      left: 159px;
      background: #001739;
      color: white;
      padding: 0 21px!important;
      border-radius: 20px!important;
      transform: filter .2s;
   }

   .btnRenovarCertificadoImg:hover {
      filter: brightness(.9);
   }
</style>


// WEBPACK FOOTER //
// src/components/menu/persistInfo/CertDigitalElement.vue